// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import {
    Avatar,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";



// main function
export default function SeriesMissingContractAvatar({ rowContractData }) {


    return (

        <Box>
            {
                ((rowContractData.comboStatus === '' || rowContractData.comboStatus === null )
                    && rowContractData.inputMissingRollup > 0 && rowContractData.inputMissingCount === 0
                    && rowContractData.contractLevel === 'Series')
                &&
                <div>
                    <Tooltip
                        enterDelay={1000}
                        title="SeriesMissingContractAvatar"
                    >
                    <Avatar sx={{
                        // ml: 1.5,
                        height: 20, width: 20, fontSize: 14, color: '#d50000',fontColor: '#d50000',  bgcolor: '#d50000'}}>_</Avatar>
                    </Tooltip>
                </div>}
        </Box>

    )

}
